import React from "react";
import "../styles/AdaptiveRule.css";

const rules = [
  "Questions unlock from Easy to Medium to Hard.",
  "You must solve the current level to move ahead.",
  "Total of 9 or 10 questions will be provided.",
  "Difficulty increases based on performance.",
  "Continous three wrong attempts can end the test.",
];

export default function AdaptiveRules({onClose,onContinue}) {
  return (
    <div className="rules-overlay">
      <div className="rules-card">
        <div className="rules-header">
          <span>⚡ Adaptive Test Rules</span>
        </div>

        <ul className="rules-list">
          {rules.map((rule, index) => (
            <li key={index}>
              <span className="rule-number">0{index + 1}</span>
              <p>{rule}</p>
            </li>
          ))}
        </ul>

        <div className="rules-actions">
          <button className="rules-cancel-btn" onClick={onClose}>
            Cancel
          </button>

          <button className="rules-btn" onClick={onContinue}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}